<template>
	<t-pane
		:background="background"
		:elevation="elevation"
		:elevationHover="elevationHover"
		:elevationActive="elevationActive"
		:border="border"
		:borderTop="borderTop"
		:borderRight="borderRight"
		:borderBottom="borderBottom"
		:borderLeft="borderLeft"
		:center="center"
		:border-radius="borderRadius || '3px'"
		:width="width"
		:height="height"
		class="card"
		v-on="$listeners"
	>
		<!-- @slot Use this slot for header -->
		<slot name="header"/>

		<slot/>

		<!-- @slot Use this slot for footer -->
		<slot name="footer"/>

	</t-pane>
</template>


<script>
import TPane from './TPane';
import layerMixin from './layerMixin.js';
export default {
	name: 'TCard',
	components: { TPane },
	mixins: [layerMixin],
	inheritAttrs: false,
};
</script>

<style lang="scss" scoped>
.card /deep/ .pane-inner {
	display: flex;
	flex-direction: column;
}
</style>

<docs>
## Examples

### Simple Card with slots
```jsx noeditor
<div>
	<t-card background="tint1" elevation="1" width="180px" height="130px">
		<div slot="header" style="padding: 8px;">Header Slot</div>
		<div style="flex: 1; padding: 8px;">Default Slot</div>
		<div slot="footer" style="padding: 8px;">Footer Slot</div>
	</t-card>
</div>
```
#### Example Code
```html
<t-card background="tint1" elevation="1">
	<div slot="header">Header Slot</div>
	<div>Default Slot</div>
	<div slot="footer">Footer Slot</div>
</t-card>
```
</docs>